import axios from 'axios'

const authHeader = "cGFyYW1vdW50Om45IXU3QGpoI3lwRjZnY3F3enhi";

export const getWebsiteData = async () => {
    return await axios.get(`${process.env.REACT_APP_WEBSITE_API}/api/website`)
}

export const getDivergenceData = async () => {
    return await axios.get(`${process.env.REACT_APP_WEBSITE_API}/api/divergence/GetDivergenceVariants/1`)
}

export const getFinishesData = async () => {
    return await axios.get(`${process.env.REACT_APP_WEBSITE_API}/api/finishes`)
}

export const register = async (email, password) => {
    return await axios({
        method: 'post',
        url: `${process.env.REACT_APP_API}/users/register`,
        data: {
            email: email,
            password: password
        }
    })
}

export const login = async (email, password) => {
    return await axios({
        method: 'post',
        url: `${process.env.REACT_APP_API}/users/login`,
        data: {
            email: "peter@test.com",
            password: "1234"
        }
    })
}

export const tokenizeCard = async (cardNumber, expirationDate, cvv) => {
    return await axios.post(
        `https://fts.cardconnect.com/cardconnect/rest/tokenize`,
        {
            account: "4444333322221111",
            expiry: "1225",
            cvv2: "123",
        },
        {
            headers: {
                Authorization: `Basic ${authHeader}`,
            },
        })
}


export const authorizePayment = async (data) => {
    return await axios.post(
        `${process.env.REACT_APP_WEBSITE_API}/api/payment/process-payment`,
        data
    )
}

export const contact = async (data) => {
    return await axios.post(
        `${process.env.REACT_APP_WEBSITE_API}/api/website/contact`,
        data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    )
}

export const customSubmission = async (data) => {
    return await axios.post(
        `${process.env.REACT_APP_WEBSITE_API}/api/website/custom`,
        data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    )
}

export const subscribeToNewsletter = async (data) => {
    return await axios.post(
        `${process.env.REACT_APP_WEBSITE_API}/api/website/subscribe`,
        data, {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    )
}

export async function createShippingLabel(rate) {
    try {
        const payload = {
            rate: rate.object_id,
            labelFileType: "PDF",
            async: false,
            carrierAccount: rate.carrier_account,
            servicelevelToken: rate.servicelevel?.token
        }

        // Make POST request to backend API
        const response = await axios.post(
            `${process.env.REACT_APP_WEBSITE_API}/api/shippo/create-label`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        // Return the label response
        return response.data;
    } catch (error) {
        console.error('Error creating shipping label:', error.response?.data || error.message);
        return null;
    }
}

export async function getShippingRates(payload) {
    try {
        // Transform payload to camelCase format expected by backend
        const requestPayload = {
            addressFrom: {
                name: payload.address_from.name,
                street1: payload.address_from.street1,
                city: payload.address_from.city,
                state: payload.address_from.state,
                zip: payload.address_from.zip,
                country: payload.address_from.country
            },
            addressTo: {
                name: payload.address_to.name,
                street1: payload.address_to.street1,
                city: payload.address_to.city,
                state: payload.address_to.state,
                zip: payload.address_to.zip,
                country: payload.address_to.country
            },
            parcels: payload.parcels.map(parcel => ({
                length: parcel.length,
                width: parcel.width,
                height: parcel.height,
                distanceUnit: parcel.distance_unit,
                weight: parcel.weight,
                massUnit: parcel.mass_unit
            }))
        };

        // Make POST request to backend API
        const response = await axios.post(
            `${process.env.REACT_APP_WEBSITE_API}/api/shippo/rates`,
            requestPayload,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        // Return shipping rates from the response
        return response.data;
    } catch (error) {
        console.error('Error fetching shipping rates:', error.response?.data || error.message);
        return null;
    }
}

export const getMailChimpCampaigns = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Mailchimp/GetCampaigns?count=100`
    )
}

export const getMailChimpCampaign = async (campaignId) => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Mailchimp/GetCampaignContent?campaignId=${campaignId}`
    )
}

// New GET endpoints
export const getHomePage = async (takeProducts = 10) => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/HomePage?takeProducts=${takeProducts}`
    )
}

export const getAnnouncement = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Announcement`
    )
}

export const getMediaPosts = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/MediaPosts`
    )
}

export const getFaqs = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Faqs`
    )
}

export const getBases = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Bases`
    )
}

export const getSlabs = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Slabs`
    )
}

export const getCarousel = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Carousel`
    )
}

export const getEmployees = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Employees`
    )
}

export const getPortfolios = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Portfolios`
    )
}

export const getTestimonials = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Testimonials`
    )
}

export const getProducts = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Products`
    )
}

export const getLookBookImages = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/LookBook`
    )
}

export const getNews = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/newsitems`
    )
}
export const getPages = async () => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Hero`
    )
}

export const getPageById = async (id) => {
    return await axios.get(
        `${process.env.REACT_APP_WEBSITE_API}/api/Hero/${id}`
    )
}

